export enum AllergiesDateTypeId {
  DAY_MONTH_YEAR = '1',
  MONTH_YEAR     = '2',
  YEAR           = '3'
}

export enum AllergiesDateTypeEntry {
  DAY_MONTH_YEAR = 'startDate',
  MONTH_YEAR     = 'startMonth',
  YEAR           = 'startYear'
}

export enum AllergiesDateHandleStartOf {
  START_YEAR  = 'year',
  START_MONTH = 'month'
}